<template>
  <div class="approach">
    <div class="media">
      <img src="../../public/img/elovate_customer_crop.png" alt="">
    </div>
    <div class="content">
      <header>
        <span class="title">Approach</span>
        <h2>A user-centered process.</h2>
      </header>
      <div class="detail">
<p>Our user-centered process begins with a discovery phase. We extract, delineate, and fine-tune business, technology, and end user needs. All requirements put forth by stakeholders are then evaluated, expanded, and refined based on objective data.</p>
<p>Armed with these insights and uncovered needs, we then move into the ideation and design phase. Before any development begins, proposed solutions are prototyped and validated by all stakeholders.</p>
<p>This critical step ensures all efforts satisfy business goals and user needs, and thus mitigates risk, optimizes scope and reduces potential for costly rework.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "approach"
};
</script>

<style lang="scss" scoped>
.approach {
  margin-top: 60px;
  display: flex;
      @media(max-width: 700px) {
        flex-direction: column;
      }
  .media {
    margin-right: 116px;
          @media(max-width: 700px) {
            margin-right: 0;
            max-width: 100%;
            img {
              max-width: 100%;
            }
      }
  }

  .content {
    position: relative;
    @media(max-width: 700px) {
      margin-left: 64px;
      background: #fff;
      margin-top: -48px;
      padding-top: 16px;
      padding-left: 16px;
    }
    .title {
      display: block;
      width: 100%;
      display: flex;
      color: rgba(0, 0, 0, 0.87);
      font-family: Archia;
      font-size: 12.19px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 16px;
      text-transform: uppercase;
      &:after {
        content: "";
        display: inline-block;
        height: 1px;
        width: 100%;
        background-color: rgba(#000, 0.87);
        position: relative;
        top: 6px;
        margin-left: 8px;
        opacity: 0.3;
      }
    }
    .detail {
      padding-right: 16px;
    }
  }
}

h2 {
  height: 24px;
  width: 471px;
  color: #1a222f;
  font-family: Archia;
  font-size: 20.32px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 24px;
  margin: 44px 0 16px 0;
}

p {
  color: #1a222f;
  font-family: Rubik;
  font-size: 16.26px;
  letter-spacing: 0.5px;
  line-height: 28px;
  opacity: .7;
}
</style>
